export default "__VITE_ASSET__DTQKxY9F__"